import { R2_PUBLIC_URL } from './runtime-config'

export const R2_CONFIG = {
  publicUrl: R2_PUBLIC_URL,
  maxFileSize: 10 * 1024 * 1024, // 10MB
  allowedMimeTypes: [
    // Documentos
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    // Imagens
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    // Texto
    'text/plain',
    'text/csv',
  ],
  maxFilesPerCommunication: 20,
}
